import { themeColor } from "./_helpers";

export const statusTokens = {
  successBg: themeColor({
    base: "{colors.success.50}",
    _themeBlack: "{colors.success.900}",
    _themeWhite: "{colors.success.50}",
  }),
  successBorder: themeColor({
    base: "{colors.success.500}",
    _themeBlack: "{colors.success.400}",
    _themeWhite: "{colors.success.500}",
  }),
  successFg: themeColor({
    base: "{colors.success.700}",
    _themeBlack: "{colors.success.400}",
    _themeWhite: "{colors.success.700}",
  }),
  warningBg: themeColor({
    base: "{colors.sunset-orange.50}",
    _themeBlack: "{colors.sunset-orange.900}",
    _themeWhite: "{colors.sunset-orange.50}",
  }),
  warningBorder: themeColor({
    base: "{colors.sunset-orange.200}",
    _themeBlack: "{colors.sunset-orange.700}",
    _themeWhite: "{colors.sunset-orange.200}",
  }),
  warningFg: themeColor({
    base: "{colors.sunset-orange.700}",
    _themeBlack: "{colors.sunset-orange.400}",
    _themeWhite: "{colors.sunset-orange.700}",
  }),
  errorBg: themeColor({
    base: "{colors.red.50}",
    _themeBlack: "{colors.red.900}",
    _themeWhite: "{colors.red.50}",
  }),
  errorBorder: themeColor({
    base: "{colors.red.500}",
    _themeBlack: "{colors.red.400}",
    _themeWhite: "{colors.red.500}",
  }),
  errorFg: themeColor({
    base: "{colors.red.700}",
    _themeBlack: "{colors.red.400}",
    _themeWhite: "{colors.red.700}",
  }),
  infoBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.primary.900}",
    _themeWhite: "{colors.primary.50}",
  }),
  infoBorder: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.500}",
  }),
  infoFg: themeColor({
    base: "{colors.primary.700}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.700}",
  }),
  aiBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.primary.900}",
    _themeWhite: "{colors.primary.50}",
  }),
  aiBorder: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.500}",
  }),
  aiFg: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.600}",
  }),
  draftBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.primary.900}",
    _themeWhite: "{colors.primary.50}",
  }),
  primaryBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.primary.700}",
    _themeWhite: "{colors.primary.50}",
  }),
  primaryBorder: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.500}",
  }),
  primaryFg: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.200}",
    _themeWhite: "{colors.primary.500}",
  }),
  draftBorder: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.500}",
  }),
  draftFg: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.500}",
  }),
  pendingBg: themeColor({
    base: "{colors.sunset-orange.50}",
    _themeBlack: "{colors.sunset-orange.900}",
    _themeWhite: "{colors.sunset-orange.50}",
  }),
  pendingBorder: themeColor({
    base: "{colors.sunset-orange.500}",
    _themeBlack: "{colors.sunset-orange.400}",
    _themeWhite: "{colors.sunset-orange.500}",
  }),
  pendingFg: themeColor({
    base: "{colors.sunset-orange.500}",
    _themeBlack: "{colors.sunset-orange.400}",
    _themeWhite: "{colors.sunset-orange.500}",
  }),
  progressBg: themeColor({
    base: "{colors.indigoCustom.50}",
    _themeBlack: "{colors.indigoCustom.900}",
    _themeWhite: "{colors.indigoCustom.50}",
  }),
  progressBorder: themeColor({
    base: "{colors.indigoCustom.500}",
    _themeBlack: "{colors.indigoCustom.400}",
    _themeWhite: "{colors.indigoCustom.500}",
  }),
  progressFg: themeColor({
    base: "{colors.indigoCustom.600}",
    _themeBlack: "{colors.indigoCustom.400}",
    _themeWhite: "{colors.indigoCustom.600}",
  }),
  neutralBg: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  neutralBorder: themeColor({
    base: "{colors.neutral.300}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.300}",
  }),
  neutralFg: themeColor({
    base: "{colors.neutral.500}",
    _themeBlack: "{colors.neutral.400}",
    _themeWhite: "{colors.neutral.500}",
  }),
  selectedZoneBg: themeColor({
    base: "{colors.indigoCustom.50}",
    _themeBlack: "{colors.indigoCustom.900}",
    _themeWhite: "{colors.indigoCustom.50}",
  }),
  deactivatedZoneBg: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.neutral.800}",
    _themeWhite: "{colors.neutral.100}",
  }),
};
